import { alertConstants } from "./alert.constants";
import { store } from "./store";

export const alertActions = {
    // clear,
    // generalError,
    // generalSuccess,
    generalErrorAndClear,
    generalSuccessAndClear,
};

// A new alert replaces the old one, so the old one's pending auto-clear must not remove it (#47238).
let pendingClear = null;

function clear() {
    return { type: alertConstants.CLEAR };
}

function scheduleClear(duration) {
    clearTimeout(pendingClear);
    pendingClear = null;
    if (duration) {
        pendingClear = setTimeout(() => {
            pendingClear = null;
            store.dispatch(clear());
        }, duration);
    }
}

function generalSuccessAndClear(message, duration) {
    scheduleClear(duration);
    return generalSuccess(message);
}

function generalErrorAndClear(message, duration) {
    scheduleClear(duration);
    return generalError(message);
}

function generalSuccess(message) {
    return { type: alertConstants.GENERAL_SUCCESS, message };
}

function generalError(message) {
    return { type: alertConstants.GENERAL_ERROR, message };
}
